<template>
    <vx-sticky-nav
        :sections="props.sections"
        class="col-span-12 lg:col-span-8 lg:col-start-3"
        contentClasses="flex mx-auto gap-2 md:gap-8 flex-col w-full max-w-(--breakpoint-sm) items-stretch"
        :navClasses="props.hideNav ? 'hidden' : ''"
    >
        <slot></slot>
    </vx-sticky-nav>
</template>

<script setup>

import { VxStickyNav } from '@voxie/frontend-components';

const props = defineProps({
    hideNav: Boolean,
    sections: Array,
})

</script>
